import { render } from "./ViewYachts.vue?vue&type=template&id=28f0830e"
import script from "./ViewYachts.vue?vue&type=script&lang=js"
export * from "./ViewYachts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__